/**
 * Deferred autoplay for media-collage videos.
 *
 * The collage's video piece used to carry `autoplay preload="auto"`, so its
 * 2.3 MB clip downloaded alongside the homepage's largest image - and a second
 * time for the copy inside the product carousel. partials/media-collage.php
 * now prints `data-pcm-autoplay` instead; this starts each one once the page
 * has finished loading and only while it is on screen, pausing it again when
 * it scrolls away. Muted, looped and inline as before, so the browser lets it
 * play without a gesture.
 */
(function () {
    'use strict';

    function start() {
        var videos = document.querySelectorAll('video[data-pcm-autoplay]');

        if (!videos.length) {
            return;
        }

        var play = function (video) {
            video.preload = 'auto';
            var attempt = video.play();

            if (attempt && typeof attempt.catch === 'function') {
                attempt.catch(function () {});
            }
        };

        if (!('IntersectionObserver' in window)) {
            Array.prototype.forEach.call(videos, play);
            return;
        }

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    play(entry.target);
                } else if (!entry.target.paused) {
                    entry.target.pause();
                }
            });
        }, { threshold: 0.25 });

        Array.prototype.forEach.call(videos, function (video) {
            observer.observe(video);
        });
    }

    if (document.readyState === 'complete') {
        start();
    } else {
        window.addEventListener('load', start);
    }
})();
